import {memoize} from 'lodash';
import memoizee from 'memoizee';
import PromiseWorker from 'promise-worker';

const MEMOIZEE_PARAMS = {maxAge: 300000};

/**
 * Creates a function that returns a memoized function for executing tasks in a web worker or the main thread.
 * Same function is also returned for the same worker URL.
 *
 * @param {string} workerURL - The URL of the web worker script.
 * @param {function} alt - The alternative function to execute in the main thread if web workers are not available.
 * @return {function} - A memoized function that executes tasks in a web worker or the main thread.
 */
export const workerFactory = memoize((workerURL, alt) => {
    if (!global.Worker) {
        console.warn('Web Worker API not available: work will be done on main thread');
    }

    const worker = global.Worker ? new Worker(workerURL) : null,
        promiseWorker = worker ? new PromiseWorker(worker) : null;

    return promiseWorker
        ? memoizee(params => promiseWorker.postMessage(params), MEMOIZEE_PARAMS)
        : memoizee(params => Promise.resolve(alt(params)), MEMOIZEE_PARAMS);
});
